import React from 'react';

const ChickenDashboardMaterialsContext = React.createContext([]);

export default ChickenDashboardMaterialsContext;
